// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";
import { connect, useDispatch } from "react-redux";
import { Box, IconButton } from "@chakra-ui/react";
import Link from "redux-first-router-link";

import {
  AuthHeader,
  RequestSentImage,
  RequestSentText,
  ResendLink,
  AuthInfoText,
  EmailSent,
} from "src/styles/auth";
import NavLinks from "src/components/auth/NavLinks";
import * as styles from "src/styles/auth";
import { getSignInEmail } from "src/reducers";
import Icon from "src/icons";
import { forgotPassword } from "src/actions/auth";

import type { AppState } from "src/types";

type Props = {
  email: string,
};

const ResetRequestSentComponent = ({ email }: Props) => {
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(forgotPassword(email));
  };

  return (
    <>
      <Box sx={styles.AuthContainer}>
        <AuthHeader>
          <Link tabIndex="-1" to="/signin/forgot">
            <IconButton mr={2} icon={<Icon type="back" />} />
          </Link>
          {i18n.t(k.PASSWORD_RESET)}
        </AuthHeader>

        <EmailSent>
          <RequestSentImage />
          <RequestSentText>{i18n.t(k.RESET_LINK_SENT)}</RequestSentText>

          <AuthInfoText>
            {i18n.t(k.RESET_INSTRUCTIONS_HAVE_BEEN_S)} <strong>{email}</strong>
            {i18n.t(k.YOU_WILL_RECEIVE)}
          </AuthInfoText>

          <ResendLink onClick={handleClick}>
            {i18n.t(k.RESENT_INSTRUCTIONS)}
          </ResendLink>
        </EmailSent>
      </Box>
      <NavLinks />
    </>
  );
};

const mapStateToProps = ({ app }: { app: AppState }) => ({
  email: getSignInEmail(app),
});

const ResetRequestSent = connect(
  mapStateToProps,
  {},
)(ResetRequestSentComponent);

export default ResetRequestSent;
